import React, { Component } from "react";
import ExportToExcel from "../../SExport/ExportToExcle";
import moment from "moment";
import {
  Button,
  // Input,
  Label,
  InputGroupAddon,
  Col,
  InputGroupText,
  Row,
} from "reactstrap";
import "./baseForms.css";
import "./formsTable.css";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import { supplierMatchesBranch } from "../../../../utils/functions";
import { generateCriteriaString } from "./../../ShortFunction/shortFunctions";
import { check_Bussiness_Permission } from "../../../../Helper";
import { Link } from "react-router-dom";

import swal from "@sweetalert/with-react";
import "./myReactSelect.css";
import "../../../../index.css";
import "react-datepicker/dist/react-datepicker.css";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { checkPermission } from "../../../../Helper";
import jsPDF from "jspdf";
import "jspdf-autotable";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");
// var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var companySymbolCurrency = "";

const listOfColKey = [
  { align: "left", value: "invoiceDate" },
  { align: "left", value: "SUPPLIER" },
  { align: "left", value: "DocumcentNo" },
  { align: "left", value: "INVOICE_REF_NO" },
  { align: "center", value: "payments" },
  { align: "center", value: "invoiceAmount" },
  { align: "center", value: "total" },
];

const listOfColLables = [
  { align: "center", value: "Date" },
  { align: "center", value: "Supplier" },
  { align: "center", value: "Doc No" },
  { align: "center", value: "Activity" },
  { align: "center", value: "Payment" },
  { align: "center", value: "Invoice Amount" },
  { align: "center", value: "Balance" },
];
function due_Formators(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell;
  if (typeof cell === "string") {
    newCell = parseFloat(cell);
  }

  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    // newCell = companySymbolCurrency + " " + newCell;
  } else {
    newCell = "-";
  }
  return newCell;
}

function dueFormatorsTotal(cell, row, enumObject, index) {
  let newCell = "";
  let runingBalanceActualy = 0;

  if (cell) {
    newCell = parseFloat(cell);

    //runningBalance=Math.abs(runningBalance);
    if (newCell > 0) {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Dr";
    } else {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Cr";
    }
  }
  if (
    (row?.INVOICE_TYPE === 7 && row?.CrdtNoteApp !== "apply") ||
    (row?.INVOICE_TYPE === 14 && row?.CrdtNoteApp !== "apply")
  ) {
    return <div style={{ color: "red" }}>{runingBalanceActualy}</div>;
  } else {
    return <div>{runingBalanceActualy}</div>;
  }
}

function dueFormatorsPayment(cell, row, enumObject, index) {
  let newCell = "";

  if (cell) {
    newCell = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  if (cell !== "" && cell !== 0 && cell !== null) {
    newCell = companySymbolCurrency + " " + newCell;
    return <div>{newCell}</div>;
  }
}
function dueFormatorsWithoutDiv(cell, row, enumObject, index) {
  let newCell = "";
  let runingBalanceActualy = 0;

  if (cell) {
    newCell = parseFloat(cell);

    //runningBalance=Math.abs(runningBalance);
    if (newCell > 0) {
      runingBalanceActualy = Math.abs(newCell);
      runingBalanceActualy = runingBalanceActualy?.toLocaleString("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Dr";
    } else {
      runingBalanceActualy = Math.abs(newCell);
      let runingBalanceActualyNum = Number(runingBalanceActualy);

      if (isNaN(runingBalanceActualyNum)) {
        runingBalanceActualy = "0.00"; // ya jo default value chahiye ho
      } else {
        runingBalanceActualy = runingBalanceActualyNum.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }

      runingBalanceActualy =
        companySymbolCurrency + " " + runingBalanceActualy + " " + "Cr";
    }
  }
  return runingBalanceActualy;
}
function dueFormators(cell, row, enumObject, index) {
  let newCell = "";

  if (cell) {
    newCell = cell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  if (cell !== "" && cell !== 0 && cell !== null) {
    newCell = companySymbolCurrency + " " + newCell;

    if (
      (row.INVOICE_TYPE === 7 && row.CrdtNoteApp !== "apply") ||
      (row.INVOICE_TYPE === 14 && row.CrdtNoteApp !== "apply")
    ) {
      return <div style={{ color: "red" }}>{newCell}</div>;
    } else {
      return <div>{newCell}</div>;
    }
  }
}
const fmtAmount = (value) =>
  (Number(value) || 0).toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
// Dr = receivable from the supplier (advance), Cr = payable to the supplier.
const balanceText = (value) => {
  if (value === "" || value === null || value === undefined) return "-";
  const n = Number(value) || 0;
  if (n === 0) return fmtAmount(0);
  return `${fmtAmount(Math.abs(n))} ${n > 0 ? "Dr" : "Cr"}`;
};
function calculateDaysLeft(startDatee, endDatee) {
  if (!moment.isMoment(startDatee)) startDatee = moment(startDatee);
  if (!moment.isMoment(endDatee)) endDatee = moment(endDatee);
  return endDatee.diff(startDatee, "days");
}

class SupplierStatement extends Component {
  constructor(props) {
    super(props);
    thisContex = this;

    let tempLogedIn = false;
    let defaultdate = new Date();
    defaultdate = moment(defaultdate).format("YYYY-MM-DD");
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }

    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      activeTab: new Array(6).fill("1"),
      logInStatus: tempLogedIn,
      divcontainer: false,
      balance: "",

      totalBalance: "",
      loadingFindButton: false,
      customerName: "",
      customerEmail: "",
      defaultdate: defaultdate,
      clientLov: "",
      branchSupplierLov: [],
      suppCategLov: [],
      suppCateg_id: { id: "-1", value: "-1", label: "All" },
      fromclientLov: "",
      spanTextDate: "",
      redirect: false,
      criteriaString: "All",

      redirectSomeOnePaid: false,
      redirectToCreativeInvoice: false,
    };
  }
  onClickFormatter = (cell, row, enumObject, index) => {
    return (
      <b>
        <p
          id={cell !== "Opening Balance" ? "p1" : "static1"}
          className={
            cell === "Opening Balance" ? "noStyleOpeningBal" : "divATag"
          }
          onClick={() => {
            this.redirectToLink(row);
          }}
        >
          {cell}
        </p>
      </b>
    );
  };
  redirectToLink = (data) => {
    const { isAgh, isDollarjnction } = this.state;
    console.log("data>>", data);
    let goLink = "/CreateBill";
    if (isAgh) {
      goLink = "/CreateBill";
    } else if (isDollarjnction) {
      goLink = "/CreateBillShort";
    }
    if (data.INVOICE_TYPE === 6) {
      if (isDollarjnction) {
        window.open(
          `/#${goLink}?id=${data.purchaseId}&updateCheck=2`,
          "_blank",
        );
      } else {
        this.props.history.push({
          pathname: goLink,
          state: {
            id: data.purchaseId,
            updateCheck: 2,
          },
        });
      }
    } else if (data.INVOICE_TYPE === 7) {
      this.props.history.push({
        pathname: "/CreatePurchaseCreditNote",
        state: {
          id: data.purchaseId,
          updateCheck: 2,
        },
      });
    } else if (data.INVOICE_TYPE === 24) {
      this.props.history.push({
        pathname: "/SupplierPayments",
        state: {
          receiptMtId: data.purchaseId,
          updateCheck: 2,
        },
      });
    }
  };
  setDelete = (row) => {
    let id = row.INVOICE_ID;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      size: "md",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/masterData/deleteInvoiceOverViewID`,
            { id: id, username: username },

            {
              headers: {
                authorization: token,
              },
            },
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            thisContex.getOverviewData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  handleChangeLovsSelect = (customer_id) => {
    this.setState((prevState) => ({
      customer_id,
      customerName: customer_id?.label,
      // Only set customerfrom_id if it is not already selected
      customerfrom_id: prevState.customerfrom_id || customer_id,
      customerNameFrom: prevState.customerfrom_id?.label || customer_id?.label,
    }));
  };

  handleChangeLovsSelectfrom = (customerfrom_id) => {
    this.setState({
      customerfrom_id,
      customerNameFrom: customerfrom_id?.label,
    });
  };

  handleToChangeOpen = (branch) => {
    let result = [];

    if (branch && branch.id === null) {
      result = this.state.clientLov;
    } else {
      result = this.state.clientLov.filter((item) =>
        supplierMatchesBranch(item, branch),
      );
    }

    console.log("result==>>", branch, this.state.clientLov, result);
    this.setState({
      branch,
      branchSupplierLov: result,
      customer_id: null,
      customerfrom_id: null,
    });
  };
  handleChangeSuppCateg = (suppCateg_id) => {
    this.setState({
      suppCateg_id,
      customer_id: null,
      customerfrom_id: null,
      customerName: "",
      customerNameFrom: "",
    });
  };

  getFilteredSuppliers = () => {
    const { isEggSpectation, branchSupplierLov, clientLov, suppCateg_id } =
      this.state;
    const list = isEggSpectation ? branchSupplierLov : clientLov;
    const suppliers = Array.isArray(list) ? list : [];

    if (
      suppCateg_id &&
      suppCateg_id.id !== undefined &&
      suppCateg_id.id !== null &&
      String(suppCateg_id.id) !== "-1" &&
      String(suppCateg_id.id) !== ""
    ) {
      return suppliers.filter(
        (item) => String(item.supp_categ_id) === String(suppCateg_id.id),
      );
    }
    return suppliers;
  };
  validateNumber = (value, defaultValue = 0) => {
    if (typeof value === "number" && !isNaN(value) && value !== 0) {
      return value;
    }
    return defaultValue;
  };
  funPrintView = (data1, headers, headerKeyMap, allData) => {
    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";

    this.props.history.push({
      pathname: "/PrintReports",
      state: {
        data: data1,
        headers: headers,
        headerKeyMap: headerKeyMap,
        goBackUrl: "/MutiSupplierStatementReport",
        dynamicInvMessage: "Multiple Supplier Statement Report",
        reportName: "Supplier_Statement_Report",
        criteriaString: this.state?.criteriaString,
      },
    });
  };

  // Statement-style PDF built here rather than through the shared
  // /PrintReports page (A2 sheet, no footer row). A4 landscape — the Supplier
  // and Activity columns need the width: header with the criteria, the four
  // summary figures, the ledger table with the grand totals as its footer
  // (last page only), and "Page x of y" on every page.
  downloadStatementPdf = () => {
    const rows = this.state.OverViewDataTable || [];
    const summary = this.state.summary;
    const meta = this.state.meta || {};
    if (!rows.length || !summary) return;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 12;
    const brand = [63, 14, 128];
    const muted = [100, 100, 110];
    const companyName = localStorage.getItem("companyName") || "";
    const printedBy = localStorage.getItem("firstName") || username || "";
    const fmtDate = (d) => (d ? moment(d).format("DD-MMM-YYYY") : "");

    // Header
    doc.setFillColor(...brand);
    doc.rect(0, 0, pageW, 3, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(30, 30, 30);
    doc.text(companyName, margin, 14);
    doc.setFontSize(12);
    doc.setTextColor(...brand);
    doc.text("MULTIPLE SUPPLIER STATEMENT", pageW - margin, 14, {
      align: "right",
    });
    doc.setDrawColor(220, 220, 228);
    doc.line(margin, 18, pageW - margin, 18);

    const detail = (label, value, x, y, align) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...muted);
      doc.text(label, x, y, { align });
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(30, 30, 30);
      doc.text(String(value || "-"), x, y + 4.5, { align });
    };
    detail(
      `Suppliers (${summary.supplierCount})`,
      meta.supplierRange,
      margin,
      24,
    );
    detail(
      "Branch" + (meta.categoryName ? " / Category" : ""),
      meta.branchName + (meta.categoryName ? `  /  ${meta.categoryName}` : ""),
      margin,
      34,
    );
    detail(
      "Statement Period",
      `${fmtDate(meta.fromDate)}  to  ${fmtDate(meta.toDate)}`,
      pageW - margin,
      24,
      "right",
    );
    detail(
      "Printed",
      `${moment().format("DD-MMM-YYYY hh:mm A")}  by ${printedBy}`,
      pageW - margin,
      34,
      "right",
    );

    // Summary boxes
    const boxes = [
      ["Opening Balance", balanceText(summary.opening)],
      ["Total Payments", fmtAmount(summary.payments)],
      ["Net Invoiced", fmtAmount(summary.invoiced)],
      ["Closing Balance", balanceText(summary.closing)],
    ];
    const gap = 3;
    const boxW = (pageW - margin * 2 - gap * 3) / 4;
    const boxY = 44;
    boxes.forEach(([label, value], i) => {
      const x = margin + i * (boxW + gap);
      const isClosing = i === boxes.length - 1;
      doc.setFillColor(...(isClosing ? brand : [246, 244, 250]));
      doc.setDrawColor(...(isClosing ? brand : [226, 222, 236]));
      doc.roundedRect(x, boxY, boxW, 15, 1.5, 1.5, "FD");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7.5);
      doc.setTextColor(...(isClosing ? [230, 222, 245] : muted));
      doc.text(label.toUpperCase(), x + 3, boxY + 5.5);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10.5);
      doc.setTextColor(...(isClosing ? [255, 255, 255] : [30, 30, 30]));
      doc.text(value, x + boxW - 3, boxY + 11.5, { align: "right" });
    });

    // Same rule as the on-screen red text: unapplied credit notes / refunds.
    const isContra = (r) =>
      (r.INVOICE_TYPE === 7 || r.INVOICE_TYPE === 14) &&
      r.CrdtNoteApp !== "apply";

    const body = rows.map((r) => [
      r.invoiceDate || "",
      r.SUPPLIER || "",
      r.DocumcentNo === undefined || r.DocumcentNo === null
        ? ""
        : String(r.DocumcentNo),
      r.INVOICE_REF_NO || "",
      Number(r.payments) ? fmtAmount(r.payments) : "",
      Number(r.invoiceAmount) ? fmtAmount(r.invoiceAmount) : "",
      balanceText(r.total),
    ]);

    doc.autoTable({
      startY: boxY + 21,
      margin: { left: margin, right: margin, bottom: 16 },
      head: [
        [
          "Date",
          "Supplier",
          "Doc No",
          "Activity",
          "Payment",
          "Invoice Amount",
          "Balance",
        ],
      ],
      body,
      foot: [
        [
          { content: "Total", colSpan: 4, styles: { halign: "left" } },
          fmtAmount(summary.payments),
          fmtAmount(summary.invoiced),
          balanceText(summary.closing),
        ],
      ],
      showFoot: "lastPage",
      showHead: "everyPage",
      theme: "grid",
      styles: {
        font: "helvetica",
        fontSize: 8,
        cellPadding: { top: 1.8, bottom: 1.8, left: 2, right: 2 },
        lineColor: [226, 226, 232],
        lineWidth: 0.1,
        textColor: [35, 35, 35],
        valign: "middle",
      },
      headStyles: {
        fillColor: brand,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },
      footStyles: {
        fillColor: [236, 231, 246],
        textColor: brand,
        fontStyle: "bold",
        fontSize: 8.5,
        halign: "right",
      },
      alternateRowStyles: { fillColor: [250, 249, 253] },
      columnStyles: {
        0: { cellWidth: 22, halign: "center" },
        1: { cellWidth: 50, halign: "left" },
        2: { cellWidth: 18, halign: "center" },
        3: { cellWidth: "auto", halign: "left" },
        4: { cellWidth: 28, halign: "right" },
        5: { cellWidth: 28, halign: "right" },
        6: { cellWidth: 32, halign: "right", fontStyle: "bold" },
      },
      didParseCell: (cell) => {
        if (cell.section !== "body") return;
        const r = rows[cell.row.index];
        if (r?.INVOICE_REF_NO === "Opening Balance") {
          cell.cell.styles.fontStyle = "bold";
          cell.cell.styles.fillColor = [241, 238, 248];
        } else if (r && isContra(r) && cell.column.index >= 5) {
          cell.cell.styles.textColor = [200, 35, 51];
        }
      },
      didDrawPage: () => {
        doc.setDrawColor(220, 220, 228);
        doc.line(margin, pageH - 11, pageW - margin, pageH - 11);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(7.5);
        doc.setTextColor(...muted);
        doc.text("Multiple Supplier Statement", margin, pageH - 6.5);
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of {total_pages}`,
          pageW - margin,
          pageH - 6.5,
          { align: "right" },
        );
      },
    });

    let y = doc.lastAutoTable.finalY + 6;
    if (y > pageH - 24) {
      doc.addPage();
      y = 20;
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.setTextColor(...muted);
    const noteLines = doc.splitTextToSize(
      "Dr = receivable from the supplier; Cr = payable to the supplier. " +
        "Red figures (unapplied credit notes / refunds) are netted off Invoice Amount. " +
        "Closing Balance is the sum of every supplier's closing balance.",
      pageW - margin * 2,
    );
    doc.text(noteLines, margin, y);
    doc.text(
      "This is a computer-generated statement and does not require a signature.",
      margin,
      y + 4 * noteLines.length,
    );

    doc.putTotalPages("{total_pages}");
    doc.save(
      `Supplier Statement - ${moment(meta.fromDate).format(
        "DD-MM-YYYY",
      )} to ${moment(meta.toDate).format("DD-MM-YYYY")}.pdf`,
    );
  };

  async getSupplierStatement(supplierId, supplierIdfrom, startDate, endDate , suppCategId ) {
    var balance = 0;
    let docArray = [];
    let docSuppPayArray = [];
    // 1st call for Load data in Data table. We are on the main page.
    let isLoadedName = this.props.location.state?.idFromClientOverview;

    try {
      const docResponse = await axios.post(
        `${baseurl}/repots/getMultiplePurchaseDocNo`,
        {
          companyId: companyId,
          supplierId: supplierId,
          supplierIdfrom: supplierIdfrom,
          suppCategId: suppCategId,
          username: username,
          startDate: startDate,
          endDate: endDate,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      let res = docResponse.data.data;
      let duplicatePaymentNo;
      let docNo;
      let purchaseInvoiceDocNo;
      console.log("checkkkkkk", res);
      for (var i = 0; i < res.length; i++) {
        if (res[i]["payment_id"] === res[i + 1]?.payment_id) {
          duplicatePaymentNo = res[i]["payment_id"];
          docNo = `${res[i]["payment_no"]}, ${res[i + 1]?.payment_no}`;
          docArray.push({
            docNo: docNo,
            receiptId: res[i]["payment_id"],
          });
        }
        if (res[i]["payment_id"] !== res[i + 1]?.payment_id) {
          purchaseInvoiceDocNo = res[i]["payment_no"];
          docSuppPayArray.push({
            docNo: purchaseInvoiceDocNo,
            receiptId: res[i]["payment_id"],
          });
        }
      }

      const statementResponse = await axios.post(
        `${baseurl}/repots/getMultipleSupplierStatement`,
        {
          idFromClientOverview: isLoadedName,
          companyId: companyId,
          supplierId: supplierId,
          supplierIdfrom: supplierIdfrom,
          branch: this.state.branch?.id,
          suppCategId : suppCategId ,
          startDate: startDate,
          username: username,
          endDate: endDate,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      this.processSupplierStatementData(
        statementResponse.data,
        docArray,
        docSuppPayArray,
      );
    } catch (error) {
      console.log(error);
    }
  }

  processSupplierStatementData(responseData, docArray, docSuppPayArray) {
    let callData = responseData.data;
    let newArr = [];
    let printData = [];
    let currentSupplier = "";
    let sumBalance = 0;

    let indexIncreament = 0;
    let indexReceiptIncreament = 0;

    // Grand totals across every supplier in the range, built with the same
    // rule as the running balance so Opening + Payments - Invoices = Closing.
    // Credit notes (book 7) sit in the Invoice Amount column but raise the
    // balance, so they are netted off the invoice total, not added to it.
    // The closing is the SUM of each supplier's last balance — the old
    // Balance box used the last row only, i.e. the last supplier's balance.
    let totals = { opening: 0, payments: 0, invoiced: 0, entries: 0 };
    let closingBySupplier = {};

    for (let i = 0; i < callData.length; i++) {
      let item = callData[i];
      let supplier = item["SUPPLIER"];

      // If new supplier, add opening balance
      if (currentSupplier !== supplier) {
        currentSupplier = supplier;
        // Only an 'O' row carries the opening. The query drops the 'O' row when
        // the opening is zero, so the first row can be a real document — e.g. an
        // advance payment, whose Debit would otherwise be taken as the opening
        // and then added again below (Dollar: 65,900 advance showed as 131,800).
        sumBalance = item["Flag"] === "O" ? item["Debit"] || 0 : 0;
        totals.opening += Number(sumBalance) || 0;
        closingBySupplier[supplier] = Number(sumBalance) || 0;

        if (sumBalance === 0) {
          newArr.push({
            invoiceDate: "",
            INVOICE_REF_NO: "Opening Balance",
            SUPPLIER: supplier,
            invoiceDueDate: "",
            invoiceAmount: "",
            payments: "",
            total: "",
          });
        } else {
          newArr.push({
            invoiceDate: "",
            INVOICE_REF_NO: "Opening Balance",
            SUPPLIER: supplier,
            invoiceDueDate: "",
            invoiceAmount: "",
            payments: "",
            total: sumBalance,
          });
        }
      }

      if (item["Flag"] == "O") {
        continue;
      }

      if (item["total_un_applied_amount"] !== 0) {
        sumBalance += +item["total_un_applied_amount"];
        totals.payments += Number(item["total_un_applied_amount"]) || 0;
      } else if (item["INV_BOOK_ID"] === 7) {
        sumBalance += +item["Credit"];
        totals.invoiced -= Number(item["Credit"]) || 0;
      } else {
        sumBalance = sumBalance - item["Credit"];
        totals.invoiced += Number(item["Credit"]) || 0;
      }
      closingBySupplier[supplier] = Number(sumBalance) || 0;
      let Activity = "";
      let docNo = "";

      if (item["INV_BOOK_ID"] === 6) {
        Activity = item["PURCH_INVOICE_REF_NO"] + " - " + "Purchase";
        docNo = item["Activity"];
      }
      if (item["INV_BOOK_ID"] === 7) {
        Activity = item["PURCH_INVOICE_REF_NO"] + " " + "Unapplied Credit Note";
        docNo = item["Activity"];
      }
      if (item["INV_BOOK_ID"] === 14) {
        Activity =
          "Refund apply on purch No" +
          " " +
          item["appliedDoc"] +
          " " +
          item["remarks"];
        docNo = item["Activity"];
      }
      if (item["Activity"] === "apply") {
        Activity =
          "Credit Note Applied on purch No " +
          " " +
          item["appliedDoc"] +
          " " +
          item["remarks"];
        docNo = item["INV_BOOK_ID"];
      }
      if (item["INV_BOOK_ID"] === 24) {
        if (
          docArray !== undefined &&
          item["purchaseId"] === docArray[indexIncreament]?.receiptId
        ) {
          let remarks = item["remarks"]?.trim() || "";
          if (remarks) {
            Activity =
              remarks +
              " " +
              " -" +
              " " +
              "Supplier Payment of purchase no(s)" +
              " " +
              docSuppPayArray[indexReceiptIncreament]?.docNo;
          } else {
            Activity =
              "Supplier Payment of purchase no(s) " +
              docSuppPayArray[indexReceiptIncreament]?.docNo;
          }
        }
        if (
          docSuppPayArray !== undefined &&
          item["purchaseId"] !== docArray[indexIncreament]?.receiptId
        ) {
          let remarks = item["remarks"]?.trim() || "";
          if (remarks) {
            Activity =
              item["remarks"] +
              " " +
              " -" +
              " " +
              "Supplier Payment of purchase no(s)" +
              " " +
              docSuppPayArray[indexReceiptIncreament]?.docNo;
          } else {
            Activity =
              "Supplier Payment of purchase no(s) " +
              docSuppPayArray[indexReceiptIncreament]?.docNo;
          }
          if (docSuppPayArray.length - 1 > indexReceiptIncreament)
            indexReceiptIncreament++;
        }
        if (docArray !== undefined && docArray.length - 1 > indexIncreament)
          indexIncreament++;
        docNo = item["Activity"];
      }

      if (
        (item["Credit"] !== 0 && item["Credit"] !== "") ||
        (item["total_un_applied_amount"] !== 0 &&
          item["total_un_applied_amount"] !== "")
      ) {
        newArr.push({
          invoiceDate: item["date"],
          SUPPLIER: supplier,
          INVOICE_REF_NO: Activity,
          invoiceDueDate: "",
          invoiceAmount: item["Credit"],
          payments: item["total_un_applied_amount"],
          total: sumBalance,
          DocumcentNo: docNo,
          INVOICE_TYPE: item["INV_BOOK_ID"],
          CrdtNoteApp: item["Activity"],
          purchaseId: item["purchaseId"],
        });
        totals.entries++;
      }
    }

    const suppliers = Object.keys(closingBySupplier);
    let totalBalance = suppliers.reduce(
      (acc, s) => acc + closingBySupplier[s],
      0,
    );
    const summary = {
      ...totals,
      closing: totalBalance,
      supplierCount: suppliers.length,
    };

    let neArr = [];
    let objTableName = {
      invoiceDate: "Account Statement Report",
      SUPPLIER: "",
      INVOICE_REF_NO: "",
      invoiceDueDate: "",
      invoiceAmount: " ",
      payments: "",
      total: "",
    };
    let objTableHeader = {
      invoiceDate: " Date",
      INVOICE_REF_NO: "Activity",
      SUPPLIER: " Supplier",
      invoiceDueDate: " Due Date",
      invoiceAmount: "Invoice Amount ",
      payments: " Payment",
      total: " Balance",
    };

    neArr.push(objTableName, objTableHeader);

    for (let index = 0; index < newArr.length; index++) {
      neArr.push(newArr[index]);
      let element = newArr[index];
      printData.push({
        invoiceDate: element.invoiceDate,
        SUPPLIER: element.SUPPLIER,
        DocumcentNo: element.DocumcentNo,
        INVOICE_REF_NO: element.INVOICE_REF_NO,
        payments: due_Formators(element.payments),
        invoiceAmount: due_Formators(element.invoiceAmount),
        total: dueFormatorsWithoutDiv(element.total),
      });
    }

    neArr.push({
      invoiceDate: "",
      INVOICE_REF_NO: "",
      SUPPLIER: "",
      invoiceDueDate: "",
      invoiceAmount: " ",
      payments: "",
      total: "",
    });

    let objCrDr = {
      invoiceDate: "Total",
      SUPPLIER: "",
      INVOICE_REF_NO: "",
      invoiceDueDate: "",
      invoiceAmount: summary.invoiced,
      payments: summary.payments,
      total: totalBalance,
    };
    neArr.push(objCrDr);

    printData.push({
      invoiceDate: "Total",
      SUPPLIER: "",
      DocumcentNo: "",
      INVOICE_REF_NO: "",
      payments: fmtAmount(summary.payments),
      invoiceAmount: fmtAmount(summary.invoiced),
      total: balanceText(totalBalance),
    });

    thisContex.setState({
      OverViewDataTable: newArr,
      totalBalance: totalBalance.toFixed(4),
      newArr: neArr,
      printData: printData,
      summary,
    });
    console.log("neArr before export:", newArr);
  }

  redirectToOrder = (cell, row) => {
    if (row.t === "INV" && cell === "someOnePaid") {
      this.setState({
        redirectSomeOnePaid: true,
        idd: row.CUSTOMER_ID,
        propInvoiceId: row.INVOICE_ID,
      });
    } else if (row.t === "RET" && cell === "someOnePaid") {
      this.setState({
        redirectCreditNoteApp: true,
        propsCustomerId: row.CUSTOMER_ID,
        propsDue: row.due,
        propsIssuedDate: row.issued_date,
        propsName: row.name,
        propsRefNo: row.no,
        propsPaid: row.creditNoteAmount,
      });
    } else if (cell === "update") {
      this.setState({
        redirect: true,
        id: row.INVOICE_ID,
        updateCheck: 0,
      });
    }

    if ((row.paid > 0 && cell === "view") || row.Paid === "Paid") {
      this.setState({
        redirectToCreativeInvoice: true,
        id: row.INVOICE_ID,
        updateCheck: 1,
      });
    } else if (row.paid === 0 && cell === "view") {
      this.setState({
        redirectToCreativeInvoice: true,
        id: row.INVOICE_ID,
        updateCheck: 0,
      });
    }
  };

  statusFormator = (cell, row, enumObject, index) => {
    let today = thisContex.state.defaultdate;
    let daysLeft = calculateDaysLeft(today, cell);
    if (cell !== "Invalid date" && row.due > 0) {
      return (
        <div>
          {cell !== "Invalid date" && daysLeft > 0 ? (
            <span className="mr-1 badge badge-warning">
              {daysLeft} days left
            </span>
          ) : (
            <span className="mr-1 badge badge-danger">
              {Math.abs(daysLeft)} days over{" "}
            </span>
          )}

          {row.paid === 0 ? (
            <>
              <span>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="success"
                  onClick={() => {
                    this.redirectToOrder("update", row);
                  }}
                >
                  Update
                </Button>
              </span>
              <span>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="danger"
                  onClick={() => this.setDelete(row)}
                >
                  Delete
                </Button>
              </span>
            </>
          ) : null}
          {row.due !== 0 && row.PostedYN === 1 ? (
            <Button
              // type="cancel"
              color="primary"
              className="mr-1"
              size="sm"
              onClick={() => {
                this.redirectToOrder("someOnePaid", row);
              }}
            >
              <i className="fa fa-euro"></i>
              <i className="fa fa-euro"></i>
            </Button>
          ) : null}

          <Button
            className="mr-1"
            size="sm"
            onClick={() => {
              this.redirectToOrder("view", row);
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </div>
      );
    } else if (row.due === 0) {
      return (
        <>
          <span>
            <Button className="mr-1" size="sm">
              Paid
            </Button>
          </span>
          <span>
            <Button
              className="mr-1"
              size="sm"
              onClick={() => {
                this.redirectToOrder(cell, row);
              }}
            >
              <i className="fa fa-eye"></i>
            </Button>
          </span>
        </>
      );
    }
  };

  async componentDidMount() {
    await this.asyncRollCheck(0);
    this.getSuppliers();
    this.getSuppCateg();
    await this.checkBussinessPermission();
    this.getBranchLov();
  }
  asyncRollCheck = async (value) => {
    let pathname = "/SupplierStatement";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission && value === 3) {
      return true;
    }
  };
  async checkBussinessPermission() {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission);
    let {
      business_type_id,
      isCrumble,
      isAgh,
      isDollarjnction,
      isEggSpectation,
    } = checkBussinessPermission;
    if (isAgh) {
      this.setState({
        isAgh,
      });
    }
    if (isDollarjnction) {
      this.setState({
        isDollarjnction,
      });
    }
    if (isEggSpectation) {
      this.setState({
        isEggSpectation,
      });
    }
  }
  getSuppliers() {
    axios
      .post(
        `${baseurl}/lovs/getSuppliers`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        let mydata = [];

        let responseData = response.data.data;
        console.log("responseData", responseData);
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["SUPPLIER_CODE"],
            value: responseData[loop]["SUPPLIER_CODE"],
            label:
              responseData[loop]["SUPPLIER_CODE"] +
              " | " +
              responseData[loop]["COMPANY_NAME"],
            supp_categ_id: responseData[loop]["supp_categ_id"],
          });
        }

        thisContex.setState({
          clientLov: mydata,
          fromclientLov: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  getSuppCateg() {
    axios
      .post(
        `${baseurl}/singleScreenOv/getSuppCateg`,
        { companyId: companyId, username: username },
        { headers: { authorization: token } },
      )
      .then((response) => {
        let mydata = [];
        let responseData = response.data.data;
        mydata.push({ id: "-1", value: "-1", label: "All" });
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["supp_categ_id"],
            label: responseData[loop]["desc1"],
            value: responseData[loop]["supp_categ_id"],
          });
        }
        thisContex.setState((prev) => ({
          suppCategLov: mydata,
          suppCateg_id:
            prev.suppCateg_id && prev.suppCateg_id.id
              ? prev.suppCateg_id
              : mydata[0],
        }));
      })
      .catch((error) => console.log(error));
  }

  onChangeHandler = (e) => {
    thisContex.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChangeStartDate = (e) => {
    thisContex.setState({
      startDate: e,
    });
  };
  getBranchLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getDynamicBranchLov`,

        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then(function (response) {
        let responseData = response.data.data;
        const allObj = {
          id: null,
          value: null,
          label: "All",
        };
        responseData.unshift(allObj);
        thisContex.setState({
          branchLov: responseData,
        });
      })
      .catch(function (error) {
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
        console.log(error);
      });
  };
  handleChangeEndDate = (e) => {
    var startDate = moment(thisContex.state.startDate).format("YYYY-MM-DD");
    var endDate = moment(e).format("YYYY-MM-DD");
    if (startDate <= endDate) {
      thisContex.setState({
        endDate: e,
        spanTextDate: "",
      });
    } else {
      thisContex.setState({
        //endDate: " " ,
        spanTextDate: "To date is greater than or equal to From date",
      });
    }
  };
  async loadingFindButtonToggle() {
    this.setState({
      loadingFindButton: !this.state.loadingFindButton,
    });
  }
  findBtn = async (e) => {
    e.preventDefault();
    await this.loadingFindButtonToggle();

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.branch
    ) {
      var supplierId = this.state.customer_id?.id || null;
      var supplierIdfrom = this.state.customerfrom_id?.id || null;
      var startDate = moment(new Date(thisContex.state.startDate)).format(
        "YYYY-MM-DD",
      );
      var endDate = moment(new Date(thisContex.state.endDate)).format(
        "YYYY-MM-DD",
      );
      let suppCategId = this.state.suppCateg_id?.id;

      if (supplierId && supplierIdfrom && Number(supplierId) > Number(supplierIdfrom)) {
        swal(
          "Warning",
          "Supplier ID cannot be Greater than Supplier From ID!",
          "warning",
        );
        await this.loadingFindButtonToggle();
        return;
      }

      const fromLabel = this.state.customer_id?.label;
      const toLabel = this.state.customerfrom_id?.label;
      let supplierRange = "All";
      if (fromLabel && toLabel) {
        supplierRange = fromLabel === toLabel ? fromLabel : `${fromLabel}  to  ${toLabel}`;
      } else if (fromLabel || toLabel) {
        supplierRange = fromLabel || toLabel;
      }

      var critObj = {
        fromDate: startDate,
        toDate: endDate,
        supplier_id: supplierId,
        supplier_idfrom: supplierIdfrom,
        multiSuppLabel: fromLabel || "All",
        multiPosBranchLabel: this.state.branch?.label,
        multifromSuppLabel: toLabel || "All",
        multiPosBranch: this.state.branch?.id,
        branch_id: this.state.branch,
      };

      const criteriaString = generateCriteriaString(critObj);
      this.setState({
        criteriaString: criteriaString,
        meta: {
          supplierRange: supplierRange,
          branchName: this.state.branch?.label || "",
          categoryName:
            this.state.suppCateg_id?.id && String(this.state.suppCateg_id.id) !== "-1"
              ? this.state.suppCateg_id.label
              : "All",
          fromDate: startDate,
          toDate: endDate,
        },
      });
      console.log("criteriaString :>> ", criteriaString);

      await this.getSupplierStatement(
        supplierId,
        supplierIdfrom,
        startDate,
        endDate,
        suppCategId,
      );
      await this.loadingFindButtonToggle();
    } else {
      await this.loadingFindButtonToggle();
      swal({
        title: "Complete Criteria required!",
        text: "Please select Branch, From-Date and To-Date and then find again",
        icon: "warning",
      });
    }
  };
  render() {
    const { OverViewDataTable, newArr, loadingFindButton, isEggSpectation } =
      this.state;
    const summary = this.state.summary;
    const meta = this.state.meta || {};
    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 15,
      pageStartIndex: 1,
      paginationSize: 3,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: OverViewDataTable?.length,
        },
      ],
    };
    return (
      <div className="animated fadeIn">
        <Row className="Creative-Invoice-header-styling">
          <Col xs="6" className="card-header-Creative-Invoice">
            <h4>Multiple Supplier Statement</h4>
          </Col>
          <Col xs="6" className="card-header-Creative-Invoice">
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Link
                to={{
                  pathname: "/AddSuppliers",
                }}
                title={"Suppliers Overview"}
                style={{
                  fontFamily: "Times New Roman",
                  fontWeight: "normal",
                  margin: "10px",
                }}
              >
                <u className="Back-to-Overview">Back to Overview</u>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-chevron-left mx-2 icon-color"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </Link>
            </div>
          </Col>
        </Row>
        <br></br>
        <Row className="rowStyling">
          <Col>
            <div className="row">
              <div className="col-md-3">
                <Select
                  value={this.state.branch}
                  onChange={this.handleToChangeOpen}
                  options={this.state.branchLov}
                  autoFocus
                  required
                  name="selectedOptionPhase"
                  placeholder={"Select Branch"}
                  isDisabled={this.state.disabled ? true : false}
                />
              </div>
              <div className="col-md-3">
                <Select
                  value={this.state.suppCateg_id}
                  onChange={this.handleChangeSuppCateg}
                  options={this.state.suppCategLov}
                  autoFocus
                  placeholder={"Select Category"}
                  isClearable
                  isDisabled={this.state.disabled}
                  isLoading={
                    !this.state.suppCategLov ||
                    this.state.suppCategLov.length === 0
                  }
                />
              </div>
              <div className="col-md-3">
                <Select
                  value={this.state.customer_id}
                  onChange={this.handleChangeLovsSelect}
                  options={this.getFilteredSuppliers()}
                  autoFocus
                  name="selectedOptionPhase"
                  placeholder={"Select from Supplier"}
                  isClearable
                  isDisabled={this.state.disabled}
                />
              </div>
              <div className="col-md-3">
                <Select
                  value={this.state.customerfrom_id}
                  onChange={this.handleChangeLovsSelectfrom}
                  options={this.getFilteredSuppliers()}
                  autoFocus
                  name="selectedOptionPhase"
                  placeholder={"Select to Supplier"}
                  isClearable
                  isDisabled={this.state.disabled}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-3">
                <Label style={{ fontWeight: "bold" }}>
                  From Date:
                  <h8 style={{ color: "tomato" }}>*</h8>
                </Label>
                <div className=" d-flex flex-row">
                  <DatePicker
                    className="form-control"
                    id="startDate"
                    name="startDate"
                    placeholderText="dd-mm-yyyy"
                    dateFormat="dd-MM-yyyy"
                    selected={thisContex.state.startDate}
                    required
                    value={thisContex.state.startDate}
                    // min={moment(new Date()).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      this.handleChangeStartDate(e);
                    }}
                  />
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="calended_icon">
                      <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                    </InputGroupText>
                  </InputGroupAddon>
                </div>
              </div>
              <div className="col-md-3">
                <Label style={{ fontWeight: "bold" }}>
                  To Date:
                  <span style={{ color: "tomato" }}>*</span>
                </Label>
                <div className="d-flex flex-row">
                  <DatePicker
                    className="form-control"
                    id="endDate"
                    name="endDate"
                    placeholderText="dd-mm-yyyy"
                    dateFormat="dd-MM-yyyy"
                    selected={thisContex.state.endDate}
                    required
                    value={thisContex.state.endDate}
                    // min={moment(new Date()).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      this.handleChangeEndDate(e);
                    }}
                  />
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className="calended_icon">
                      <i class="fa fa-calendar-plus-o" aria-hidden="true" />
                    </InputGroupText>
                  </InputGroupAddon>
                </div>
                <span>{thisContex.state.spanTextDate}</span>
              </div>

              <div className="col-md-1">
                <Button
                  // type="submit"
                  size="md"
                  color="warning"
                  className="mr-1"
                  onClick={this.findBtn}
                  style={{ marginTop: "30px" }}
                  disabled={loadingFindButton}
                >
                  {loadingFindButton ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Find"
                  )}
                </Button>
              </div>
              <div className="col-md-2" style={{ paddingTop: "29px" }}>
                {newArr?.length > 0 ? (
                  <ExportToExcel
                    Data={newArr}
                    criteriaString={this.state?.criteriaString}
                    listOfColKey={listOfColKey}
                    DynamicReports={true}
                    ReportName="Sale_Credit_Note_Application_Report"
                  />
                ) : null}
              </div>
              <div className="col-md-2" style={{ paddingTop: "29px" }}>
                {newArr?.length > 0 && (
                  <Button
                    color="success"
                    className="ml-2"
                    onClick={() =>
                      this.funPrintView(
                        this.state.printData,
                        listOfColLables,
                        listOfColKey,
                        {
                          fromDate: this.state.startDate,
                          toDate: this.state.endDate,
                          customerName: this.state.customerName,
                        },
                      )
                    }
                  >
                    Print
                  </Button>
                )}
                {newArr?.length > 0 && summary && (
                  <Button
                    color="danger"
                    className="ml-2"
                    onClick={this.downloadStatementPdf}
                  >
                    PDF
                  </Button>
                )}
              </div>
            </div>
            {summary && (
              <div className="as_statement">
                <div className="as_statement_head">
                  <div>
                    <div className="as_label">
                      Suppliers ({summary.supplierCount})
                    </div>
                    <div className="as_value">{meta.supplierRange}</div>
                  </div>
                  {meta.branchName ? (
                    <div>
                      <div className="as_label">Branch</div>
                      <div className="as_value">{meta.branchName}</div>
                    </div>
                  ) : null}
                  {meta.categoryName ? (
                    <div>
                      <div className="as_label">Category</div>
                      <div className="as_value">{meta.categoryName}</div>
                    </div>
                  ) : null}
                  <div className="as_right">
                    <div className="as_label">Statement Period</div>
                    <div className="as_value">
                      {moment(meta.fromDate).format("DD-MMM-YYYY")} to{" "}
                      {moment(meta.toDate).format("DD-MMM-YYYY")}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="as_toggle"
                    onClick={() =>
                      this.setState({ cardsClosed: !this.state.cardsClosed })
                    }
                    title={this.state.cardsClosed ? "Show summary" : "Hide summary"}
                    aria-expanded={!this.state.cardsClosed}
                  >
                    <i
                      className={`fa fa-chevron-${
                        this.state.cardsClosed ? "down" : "up"
                      }`}
                    />
                  </button>
                </div>
                {!this.state.cardsClosed && (
                <div className="as_cards">
                  <div className="as_card">
                    <div className="as_label">Opening Balance</div>
                    <div className="as_amount">
                      {balanceText(summary.opening)}
                    </div>
                  </div>
                  <div className="as_card">
                    <div className="as_label">Total Payments</div>
                    <div className="as_amount">
                      {fmtAmount(summary.payments)}
                    </div>
                  </div>
                  <div className="as_card">
                    <div className="as_label">Net Invoiced</div>
                    <div className="as_amount">
                      {fmtAmount(summary.invoiced)}
                    </div>
                  </div>
                  <div className="as_card as_card_closing">
                    <div className="as_label">Closing Balance</div>
                    <div className="as_amount">
                      {balanceText(summary.closing)}
                    </div>
                  </div>
                </div>
                )}
              </div>
            )}
            <div className="as_table">
            <BootstrapTable
              data={OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              tableFooterClass="as_footer"
              containerClass="rpr_container"
              footer={!!summary}
              footerData={
                summary
                  ? [
                      [
                        { label: "Total", columnIndex: 0, align: "center" },
                        {
                          label: `${summary.supplierCount} supplier${
                            summary.supplierCount === 1 ? "" : "s"
                          }`,
                          columnIndex: 1,
                          align: "left",
                        },
                        { label: "", columnIndex: 2 },
                        {
                          label: `${summary.entries} ${
                            summary.entries === 1 ? "entry" : "entries"
                          }`,
                          columnIndex: 3,
                          align: "left",
                        },
                        {
                          label: fmtAmount(summary.payments),
                          columnIndex: 4,
                          align: "right",
                        },
                        {
                          label: fmtAmount(summary.invoiced),
                          columnIndex: 5,
                          align: "right",
                        },
                        {
                          label: balanceText(summary.closing),
                          columnIndex: 6,
                          align: "right",
                        },
                      ],
                    ]
                  : []
              }
              headerStyle={{
                position: "sticky",
                top: "0",
                //  zIndex: "1000"
              }}
              options={options}
            >
              <TableHeaderColumn
                dataField="invoiceDate"
                dataAlign="center"
                width="10%"
              >
                Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="SUPPLIER"
                dataAlign="left"
                headerAlign="center"
                width="12%"
              >
                Supplier
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="DocumcentNo"
                dataAlign="center"
                width="8%"
                dataFormat={this.onClickFormatter}
              >
                Doc No
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="INVOICE_REF_NO"
                dataAlign="left"
                headerAlign="center"
                width="25%"
              >
                Activity
              </TableHeaderColumn>
              {/* 
              <TableHeaderColumn
                dataField="remarks"
                dataAlign="center"
                width="20%"
              >
                Remarks
              </TableHeaderColumn> */}

              <TableHeaderColumn
                dataField="payments"
                dataAlign="right"
                headerAlign="center"
                width="15%"
                isKey={true}
                dataFormat={dueFormatorsPayment}
              >
                Payment
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="invoiceAmount"
                dataAlign="right"
                headerAlign="center"
                width="15%"
                dataFormat={dueFormators}
              >
                Invoice Amount
              </TableHeaderColumn>

              <TableHeaderColumn
                dataAlign="right"
                headerAlign="center"
                dataField="total"
                width="15%"
                dataFormat={dueFormatorsTotal}
              >
                Balance
              </TableHeaderColumn>
            </BootstrapTable>
            <div className="as_note">
              Dr = receivable from the supplier · Cr = payable to the supplier
              · Red figures (unapplied credit notes / refunds) are netted off
              the Invoice Amount total · Closing Balance is the sum of every
              supplier's closing balance
            </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SupplierStatement;
